module.exports = __webpack_public_path__ + "img/are-free-vpns-safe.9221484e.webp";